import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ModalState = {
  exitModal: boolean;
  learnMoreIds?: string[];
  learnMoreFocus?: string;
  showPrescriptionModalContinue: boolean;
  showProceedWithNoPowerModal: boolean;
  showMissingPrescriptionsValue: boolean;
  showMissingReadingAddValueModal: boolean;
  showPrescriptionModalHowToRead: {
    showModal: boolean;
    showNone?: boolean;
  };
  showDigitalOptometryModal: boolean;
  showPrescriptionModalPD: boolean;
  showPrescriptionUploadFilePreviewModal: boolean;
  showAddMyDoctorModal: boolean;
  showPaymentInstallmentsModal: boolean;
  showCallMyDoctorCalifornianModal: boolean;
  showSpeedyRxModal: boolean;
  doctorSelected: any;
  previousSearchResult: any;
  showPdWebModal?: boolean;
};

const initialState: ModalState = {
  exitModal: false,
  learnMoreFocus: null,
  learnMoreIds: null,
  showPrescriptionModalContinue: false,
  showProceedWithNoPowerModal: false,
  showMissingPrescriptionsValue: false,
  showMissingReadingAddValueModal: false,
  showPrescriptionModalHowToRead: {
    showModal: false,
    showNone: false,
  },
  showDigitalOptometryModal: false,
  showPrescriptionModalPD: false,
  showPrescriptionUploadFilePreviewModal: false,
  showAddMyDoctorModal: false,
  showPaymentInstallmentsModal: false,
  showCallMyDoctorCalifornianModal: false,
  showSpeedyRxModal: false,
  doctorSelected: null,
  previousSearchResult: null,
  showPdWebModal: false,
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState: initialState,
  reducers: {
    toggleExitModal: (state, action: PayloadAction<boolean>) => {
      state.exitModal = action.payload;
    },
    setOpenLearnMoreModal: (state, { payload }: PayloadAction<string>) => {
      state.learnMoreFocus = payload;
    },
    setListLearnMoreModal: (state, { payload }: PayloadAction<string[]>) => {
      state.learnMoreIds = payload;
    },
    setShowPrescriptionModalContinue: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showPrescriptionModalContinue = payload;
    },
    setShowProceedWithNoPowerModal: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showProceedWithNoPowerModal = payload;
    },
    setShowMissingPrescriptionsValue: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showMissingPrescriptionsValue = payload;
    },
    setShowMissingReadingAddValueModal: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showMissingReadingAddValueModal = payload;
    },
    setShowPrescriptionModalHowToRead: (
      state,
      { payload }: PayloadAction<{ showModal: boolean; showNone?: boolean }>
    ) => {
      state.showPrescriptionModalHowToRead = payload;
    },
    setShowPrescriptionModalPD: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showPrescriptionModalPD = payload;
    },
    setShowPdWebModal: (state, { payload }: PayloadAction<boolean>) => {
      state.showPdWebModal = payload;
    },
    setShowDigitalOptometryModal: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showDigitalOptometryModal = payload;
    },
    setShowPrescriptionUploadFilePreviewModal: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showPrescriptionUploadFilePreviewModal = payload;
    },
    setShowAddMyDoctorModal: (state, { payload }: PayloadAction<boolean>) => {
      state.showAddMyDoctorModal = payload;
    },
    setShowPaymentInstallmentsModal: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showPaymentInstallmentsModal = payload;
    },
    setShowCallMyDoctorCalifornianModal: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showCallMyDoctorCalifornianModal = payload;
    },
    setDoctorSelected: (state, { payload }: PayloadAction<any>) => {
      state.doctorSelected = payload;
    },
    setPreviousSearchResultState: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.previousSearchResult = payload;
    },
    setShowSpeedyRxModal: (state, { payload }: PayloadAction<boolean>) => {
      state.showSpeedyRxModal = payload;
    },
    reset: (state, { payload }: PayloadAction<string>) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key];
      });
    },
  },
});

export const modalsReducer = modalsSlice.reducer;
export const modalsActions = modalsSlice.actions;
